/**
 * Stavové panely stránok (S11, F4AI-17): loading / error / empty.
 * Každá stránka ich používa jednotne, takže skeleton má všade rovnaké
 * správanie (spinner, chybová reason veta z `ApiError.reasons`, retry).
 */
import type { JSX } from 'react';

import type { ApiError } from '../api/client.js';

export function StateLoading({ label = 'načítavam z gateway' }: { label?: string }): JSX.Element {
  return (
    <section className="glass-panel state" data-testid="state-loading" aria-busy="true">
      <div className="spinner" />
      <p className="state-title">{label}</p>
    </section>
  );
}

export function StateError({
  error,
  onRetry,
}: {
  error: ApiError;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <section className="glass-panel state state-error" data-testid="state-error" role="alert">
      <p className="state-title">gateway odpovedal chybou</p>
      <p className="state-detail">
        <code>{error.code}</code>
        {error.status > 0 ? ` · HTTP ${String(error.status)}` : ' · bez spojenia'}
      </p>
      <ul className="state-detail">
        {error.reasons.map((reason, index) => (
          <li key={index}>{reason}</li>
        ))}
      </ul>
      {onRetry !== undefined && (
        <button type="button" className="retry-btn" onClick={onRetry}>
          skúsiť znova
        </button>
      )}
    </section>
  );
}

export function StateEmpty({
  title = 'zatiaľ nič',
  hint = '',
}: {
  title?: string;
  hint?: string;
}): JSX.Element {
  return (
    <section className="glass-panel state" data-testid="state-empty">
      <p className="state-title">{title}</p>
      {hint !== '' && <p className="state-detail">{hint}</p>}
    </section>
  );
}
